<template>
  <lb-drawer
    :value="value"
    @input="$emit('input', $event)"
    :dailogboxOnly="dailogboxOnly"
    :heading="heading"
    :width="width"
    :loading="loading"
  >
    <template v-slot:body>
      <div>
        {{ message }}
      </div>
    </template>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        @click="$emit('save')"
        data-testid="unsaved-changes-drawer__save-button"
      >
        <span>Save</span>
      </v-btn>
      <v-btn
        class="ml-2"
        color="primary"
        @click="$emit('cancel')"
        data-testid="unsaved-changes-drawer__cancel-button"
      >
        <span>Cancel</span>
      </v-btn>
    </template>
  </lb-drawer>
</template>

<script>
export default {
  name: 'UnsavedChangesDrawer',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: String,
      default: 'Confirmation',
    },
    message: {
      type: String,
      default: 'Please save your changes.',
    },
    dailogboxOnly: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String, Number],
      default: 400,
    },
  },
};
</script>
